export const SM_SCREEN = 480;
export const MD_SCREEN = 768;
export const LG_SCREEN = 992;
export const XLG_SCREEN = 1200;
export const XXLG_SCREEN = 1650;
